import React from 'react';
import {
  Button,
  Modal,
  Card,
  Col,
  Form,
  Input,
  message,
  Row,
  Spin,
  Table,
  Select,
} from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { useEffect, useState, useRef } from 'react';
import { API, BEARER } from '../../constant';
import { getToken } from '../../helpers';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { toProperCase } from '../../utils/generic';
import configObject from './queryConfig/supplierMasterDumpQuery';

// console.log('amdjc', configObject);

const filterGlobalSearch = (Data, searchText, filterScope) => {
  if (!searchText) {
    return Data;
  }

  let filteredDataTemp = [];
  if (filterScope == 'all') {
    filteredDataTemp = Data.filter((value) => {
      console.log(value);
      return (
        value?.supplierName
          ?.toLowerCase()
          .includes(searchText.trim()?.toLowerCase()) ||
        value?.supplierDescription
          ?.toLowerCase()
          .includes(searchText.trim()?.toLowerCase()) ||
        value?.contactPerson
          ?.toLowerCase()
          .includes(searchText.trim()?.toLowerCase()) ||
        value?.contactEmail
          ?.toLowerCase()
          .includes(searchText.trim()?.toLowerCase()) ||
        value?.supplierType
          ?.toLowerCase()
          .includes(searchText.trim()?.toLowerCase()) ||
        value?.gstNo?.toLowerCase().includes(searchText.trim()?.toLowerCase())
      );
    });
  } else if (filterScope == 'supplierName') {
    filteredDataTemp = Data.filter((value) => {
      return value.supplierName
        .toLowerCase()
        .includes(searchText.trim().toLowerCase());
    });
  } else if (filterScope == 'contactPerson') {
    filteredDataTemp = Data.filter((value) => {
      return value.contactPerson
        .toLowerCase()
        .includes(searchText.trim().toLowerCase());
    });
  } else if (filterScope == 'ContactEmail') {
    filteredDataTemp = Data.filter((value) => {
      return value.contactEmail
        .toLowerCase()
        .includes(searchText.trim().toLowerCase());
    });
  } else if (filterScope == 'supplierDescription') {
    filteredDataTemp = Data.filter((value) => {
      return value.supplierDescription
        .toLowerCase()
        .includes(searchText.trim().toLowerCase());
    });
  } else if (filterScope == 'gstNo') {
    filteredDataTemp = Data.filter((value) => {
      return value.gstNo
        .toLowerCase()
        .includes(searchText.trim().toLowerCase());
    });
  }

  console.log(filteredDataTemp, 'filtered data', filterScope, searchText);
  if (filteredDataTemp.length > 0) {
    return filteredDataTemp;
  } else {
    filteredDataTemp.push({
      key: 0,
      id: 0,
      supplierName: 'Not Found',
      supplierDescription: 'Not Found',
      address: {
        addressDescription: 'Not Found',
        addressRefId: 0,
        city: { cityRefId: 0, cityName: 'Not Found' },
        state: { stateRefId: 0, stateName: 'Not Found' },
        country: { countryRefId: 0, countryName: 'Not Found' },
        pincode_district: 'NA',
        pincode_country: 'NA',
        pincode_state: 'NA',
      },
      status: false,
      contactPerson: 'Not Found',
      contactPhone: 'Not Found',
      contactEmail: 'Not Found',
      gstNo: 'Not Found',
    });
    return filteredDataTemp;
  }
};

const SupplierMaster = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = parseInt(searchParams.get('page'), 10) || 1;
  const searchString = searchParams?.get('searchquery') ?? '';

  const [isLoading, setIsLoading] = useState(null);
  const [isDownloading, setIsDownloading] = useState(null);

  const authToken = getToken();
  const [Data, setData] = useState([]);

  const [filterInfo, setFilterInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState('');

  const [searchText, setSearchText] = useState('');
  const [filterScope, setFilterScope] = useState('all');
  const [downloadableData, setDownloadableData] = useState([]);

  const csvLinkRef = useRef();
  const filterScopeOptionsArray = [
    'all',
    'supplierName',
    'contactPerson',
    'gstNo',
    'ContactEmail',
    'supplierDescription',
  ];

  const [alreadySelectedRows, setAlreadySelectedRows] = useState([]);

  const toSupplierDetails = (state) => {
    navigate('/supplierDetails', { state });
  };

  let data1 = [];

  const fetchData = async (token) => {
    setIsLoading(true);
    try {
      const requestedAdditionalDetails = {
        populate: [
          {
            relation: 'address',
            populate: [
              {
                relation: 'country',
                populate: null,
              },
              {
                relation: 'city',
                populate: null,
              },
              {
                relation: 'state',
                populate: null,
              },
            ],
          },
          {
            relation: 'fabrics',
            populate: null,
          },
        ],
        filters: {
          fieldsFilterConfig: [
            {
              fieldName: 'id',
              path: 'this',
              operation: 'eq',
            },
            {
              fieldName: 'supplierName',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'supplierDescription',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'contactPerson',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'contactPhone',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'supplierType',
              path: 'this',
              operation: 'containsi',
            },

            {
              fieldName: 'contactEmail',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'gstNo',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'addressDescription',
              path: 'this.address',
              operation: 'containsi',
            },
          ],
          searchString: searchText?.trim()?.toLowerCase() ?? '',
          currentFilter: [
            'id',
            'supplierName',
            'supplierDescription',
            'contactPerson',
            'contactPhone',
            'supplierType',
            'contactEmail',
            'gstNo',
            'addressDescription',
          ],
        },
        sort: {
          createdAt: 'desc',
        },
      };
      const data = { data: { requestedAdditionalDetails } };
      const response = await fetch(`${API}/suppler-master/get-populated-data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${BEARER} ${token}`,
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      console.log('response check --', responseData);
      if (responseData.error) {
        message.error('Something went wrong, please try again');
      } else {
        // return;

        data1 = responseData?.data?.completeSuccess?.map((entry) => {
          const userDetails = {
            userRefId: entry?.userDetails[0]?.user?.userID,
            userName: entry?.userDetails[0]?.user?.username,
            userEmail: entry?.userDetails[0]?.user?.email,
          };

          let addressObj = {};
          if (entry.address) {
            const addressDetails = entry.address;
            addressObj = {
              addressRefId: addressDetails.id,
              addressDescription: addressDetails.addressDescription,
              street: addressDetails.street,
              pincode: addressDetails.pincode,
              pincode_district: addressDetails.pincode_district,
              pincode_state: addressDetails.pincode_state,
              pincode_country: addressDetails.pincode_country,
              state: {
                stateRefId: addressDetails?.state?.id,
                stateName: addressDetails?.state?.stateName,
              },
              country: {
                countryRefId: addressDetails?.country?.id,
                countryName: addressDetails?.country?.countryName,
              },
              city: {
                cityRefId: addressDetails?.city?.id,
                cityName: addressDetails?.city?.cityName,
              },
            };
          }
          let fabricListObject = [];
          if (entry.fabrics.length > 0) {
            fabricListObject = entry?.fabrics?.map((fabric) => {
              let fabricRefId = fabric?.id;
              let fabricName = fabric?.fabricName;
              return { fabricRefId, fabricName };
            });
          }

          return {
            key: entry.id,
            id: entry.id,
            supplierName: entry.supplierName,
            supplierDescription: entry.supplierDescription,
            supplierType: entry.supplierType,
            address: addressObj,
            status: entry.status,
            contactPerson: entry.contactPerson,
            contactPhone: entry.contactPhone,
            contactEmail: entry.contactEmail,
            gstNo: entry.gstNo,
            fabrics: fabricListObject,
            userDetails: userDetails,
            createdAt: entry?.createdAt,
            updatedAt: entry?.updatedAt,
          };
        });

        console.log('original Data:', responseData);
        console.log('current Data after modification:', data1);

        setData(data1);
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchDataDependent = async (token, config) => {
    setIsLoading(true);
    try {
      const requestedAdditionalDetails = config;
      console.log('dependent fetch data all', config);
      const data = { data: { requestedAdditionalDetails } };
      const response = await fetch(`${API}/suppler-master/get-populated-data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${BEARER} ${token}`,
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      console.log('response check --', responseData);
      if (responseData.error) {
        message.error('Something went wrong, please try again');
      } else {
        // return;

        data1 = responseData?.data?.completeSuccess?.map((entry) => {
          const userDetails = {
            userRefId: entry?.userDetails[0]?.user?.userID,
            userName: entry?.userDetails[0]?.user?.username,
            userEmail: entry?.userDetails[0]?.user?.email,
          };

          let fabricListObject = [];
          if (entry.fabric_used_for_products.length > 0) {
            fabricListObject = entry.fabric_used_for_products?.map(
              (fabricUtil) => {
                let fabricRefId = fabricUtil?.fabric?.fabricName;
                let fabricName = fabricUtil?.fabric?.fabricName;
                let utilizationQty = fabricUtil?.utilizationQty;
                return { fabricRefId, fabricName, utilizationQty };
              }
            );
          }

          let coreProductListObject = [];
          if (entry.core_products.length > 0) {
            coreProductListObject = entry.core_products?.map((core_product) => {
              let core_productRefId = core_product.id;
              let core_productSKU = core_product.sku;
              // let fabricUtilizedAssumed = core_product.fabric_used_for_products.map(());
              return { core_productRefId, core_productSKU };
            });
          }

          return {
            key: entry.id,
            id: entry.id,
            supplierName: entry.supplierName,
            supplierDescription: entry.supplierDescription,
            supplierType: entry.supplierType,
            status: entry.status,
            contactPerson: entry.contactPerson,
            contactPhone: entry.contactPhone,
            contactEmail: entry.contactEmail,
            gstNo: entry.gstNo,
            fabrics: fabricListObject,
            coreProducts: coreProductListObject,
            userDetails: userDetails,
            createdAt: entry?.createdAt,
            updatedAt: entry?.updatedAt,
          };
        });

        console.log('Dependent original Data:', responseData);
        console.log('Dependent current Data after modification:', data1);
        return data1;
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (authToken) {
      fetchData(authToken);
    }
  }, []);

  useEffect(() => {
    if (searchText === null) {
      // setSearchParams({ page: 1, searchquery: '' });
    } else if (searchText == '') {
      setSearchParams({ page: 1, searchquery: '' });
      fetchData(authToken);
    } else {
      // let searchParameters = getSearchParameters();
      setSearchParams({ page: currentPage, searchquery: searchText });
      fetchData(authToken);
    }
  }, [searchText, filterScope]);

  const columns = [
    {
      key: 'id',
      title: 'ID',
      dataIndex: 'id',
    },
    {
      key: 'supplierName',
      title: 'Supplier Name',
      dataIndex: 'supplierName',
      sorter: (record1, record2) => {
        return record1.supplierName?.localeCompare(record2.supplierName);
      },
      sortOrder: sortedInfo.columnKey === 'supplierName' && sortedInfo.order,
    },
    {
      key: 'supplierDescription',
      title: 'Supplier Code',
      dataIndex: 'supplierDescription',
    },
    {
      key: 'supplierType',
      title: 'Supplier Type',

      render: (_, record) => {
        return toProperCase(record?.supplierType ?? '');
      },
    },
    {
      key: 'address',
      title: 'Address',
      dataIndex: 'address',
      className: 'address-detail',
      render: (_, record) => {
        console.log('addresss check ', record);
        //?. is used for not found littral added in case of record not found by filters - now we are keeping the object complete in case of record not found so we dont need ?. operator however for saftly purposes we still kept it.
        return `${record.address?.addressDescription ?? 'NA'}\n${
          record.address?.pincode_state ?? 'NA'
        }, ${record.address?.pincode_country ?? 'NA'}`;
      },
    },
    {
      key: 'status',
      title: 'Status',
      dataIndex: 'status',
      render: (_, record) => {
        return record.status ? 'Active' : 'Not Active';
      },
    },
    {
      key: 'contactPerson',
      title: 'Contact Person',
      dataIndex: 'contactPerson',
    },
    {
      key: 'contactEmail',
      title: 'Contact Email',
      dataIndex: 'contactEmail',
    },
    {
      key: 'gstNo',
      title: 'GST No',
      dataIndex: 'gstNo',
    },
    {
      key: 'userName',
      title: 'Username',
      dataIndex: 'userName',
      render: (_, record) => {
        console.log(record, record?.userDetails?.userName);
        return record?.userDetails?.userName ?? 'NA';
      },
    },
    {
      key: 'action',
      title: 'Actions',

      render: (_, record) => {
        return (
          <div>
            <div className="ActionColumn">
              <EditOutlined
                style={{ color: 'black' }}
                onClick={() => Edit(record)}
              />
              <Button
                icon={
                  <DeleteOutlined style={{ color: 'red', marginRight: 8 }} />
                }
                onClick={() => Delete(record)}
              />
            </div>
          </div>
        );
      },
    },
  ];

  const deleteRecord = async (recordID) => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/suppler-masters/${recordID}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',

          Authorization: `Bearer ${getToken()}`,
        },
      });
      const responseData = await response.json();
      console.log(responseData);

      if (responseData.error) {
        message.error('Something went wrong, please try again');
      } else {
        fetchData(getToken());
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const Delete = (record) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this',
      onOk: () => {
        deleteRecord(record.id);
      },
    });
  };

  const Edit = (record) => {
    toSupplierDetails(record);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    console.log('in handle table change', pagination, filters, sorter);
    const { order, columnKey } = sorter;
    setFilterInfo(filters);
    setSortedInfo({ columnKey, order });
    const { current } = pagination;
    setSearchParams({ page: current, searchquery: searchText });
  };

  const resetTable = () => {
    setSortedInfo({});
    setFilterInfo({});
    setSearchText('');
    setFilterScope('all');
    setAlreadySelectedRows([]);
    fetchData(authToken);
  };

  const handleChangeSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleFilterScopeChange = (value) => {
    console.log('setFilterScope', value);
    setFilterScope(value);
  }; // change in filter scope selected by user

  const getFilterOptionArray = (options) => {
    return options.map((option) => {
      return { value: option, label: option };
    });
  }; //

  const filterOptionArray = [...getFilterOptionArray(filterScopeOptionsArray)];

  const getFinalFormatedData = async () => {
    const finalDownloadableData = await getFormattedData();
    setDownloadableData(finalDownloadableData);
    setTimeout(() => {
      csvLinkRef.current.link.click(); // Manually trigger CSV download
    }, 1000); // Small delay to ensure state update
  };

  const getFormattedData = async () => {
    const downloadData = Data;
    console.log('new data from json ', configObject);
    const dynamicData = await fetchDataDependent(getToken(), configObject);
    console.log('dynamic Data ll', dynamicData);
    // return [];

    let downloadDataFormatted = dynamicData?.map((row) => {
      console.log(
        row,
        'downloading data row...',
        row?.coreProducts,
        row?.fabrics
      );

      const coreProductSkuList = row?.coreProducts?.map(
        (product) => product?.core_productSKU
      );
      const fabricNameList = row?.fabrics?.map((fabric) => {
        return `${fabric?.fabricName} : ${fabric?.utilizationQty}`;
      });
      return {
        id: row.id,
        'Supplier Name': row?.supplierName,
        'Supplier Code': row?.supplierDescription,
        'Supplier Type': toProperCase(row?.supplierType ?? ''),
        Address: `${row?.address?.addressDescription ?? 'NA'}\n${
          row.address?.pincode_state ?? 'NA'
        }, ${row.address?.pincode_country ?? 'NA'}`,
        [toProperCase('contactPerson')]: row?.contactPerson,
        Status: row?.status,
        'Contact Email': row?.contactEmail,
        'Product Supplied': row?.coreProducts?.length,
        'Product Supplied List': coreProductSkuList?.join(','),
        'Fabric Supplied': row?.fabrics?.length,
        'Fabric Supplied List': fabricNameList?.join(','),
        userName: row?.userDetails?.userName,
        CreatedDate: moment(row?.createdAt).format('DD/MM/YYYY') ?? 'NA',
      };
    });

    // console.log(downloadDataFormatted, 'downloading data 2...');
    // setIsLoading(false);
    return downloadDataFormatted;
  };

  return (
    <div>
      <h2>Supplier Master</h2>
      <Button
        onClick={() => {
          toSupplierDetails();
        }}
      >
        Add Supplier Details
      </Button>

      {/* Table Section */}
      <div className="table">
        {/* Filter search Section */}
        <div className="filterContainer">
          <div className="tableSearchSection">
            <Select
              disabled={true}
              defaultValue="all"
              className="filterScopeSelect"
              onChange={handleFilterScopeChange}
              options={filterOptionArray}
            />

            <Input
              placeholder="Enter Search Text"
              onChange={handleChangeSearch}
              type="text"
              allowClear
              value={searchText}
            ></Input>
            <Button onClick={resetTable}>Reset</Button>
            <Button
              style={{ backgroundColor: 'greenyellow', color: 'white' }}
              onClick={getFinalFormatedData}
            >
              Download {isDownloading && <Spin size="small" />}
            </Button>
            <CSVLink
              data={downloadableData}
              filename={
                'Core-Product-list-' + moment(new Date()).format('DD-MM-YYYY')
              }
              ref={csvLinkRef}
              style={{ display: 'none' }}
            />
          </div>
        </div>
        {isLoading ? (
          <Spin size="large" />
        ) : (
          <Table
            dataSource={Data}
            columns={columns}
            onChange={handleTableChange}
            pagination={{
              current: currentPage,
              pageSize: 10,
              total: Data?.length,
              position: ['bottomCenter'],
            }}
            rowSelection={{
              type: 'checkbox',
              selectedRowKeys: alreadySelectedRows,
              onChange: (keys) => {
                setAlreadySelectedRows(keys);
              },
              onSelect: (record) => {
                console.log(record, 'selected row ');
              },
              selections: [Table.SELECTION_NONE, Table.SELECTION_ALL],
            }}
          />
        )}
      </div>
    </div>
  );
};

export default SupplierMaster;
